import React from "react";
import "./footer.css";
import { useNavigate } from "react-router-dom";
import { FiFacebook, FiLinkedin } from "react-icons/fi";
import { FaBluesky } from "react-icons/fa6";

const COL3 = ["Sports", "Music", "Dance", "Academics", "Art", "Yoga"];
const COL4 = ["Coding", "Games / Hobbies", "Science", "Test Prep", "Teen Programs", "Summer Camp"];

function Footer() {
  const navigate = useNavigate();

  const goTo = (path) => (e) => {
    e.preventDefault();
    navigate(path);
    setTimeout(() => window.scrollTo(0, 0), 0);
  };

  const catLink = (cat) => `/activities?category=${encodeURIComponent(cat)}`;

  return (
    <div>
      <footer className="text-white text-center text-md-start footerbg web-only">
        <br /><br /><br /><br />
        <div>
          <div className="container p-4">
            <div className="row">

              {/* Column 1: Logo + Description */}
              <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
                <h3>
                  <a href="/" className="navbar-brand weblogo" onClick={goTo("/")}>
                    <img
                      style={{ width: "85%", height: "auto", marginTop: "-0.5rem" }}
                      src="/assets/images/logowhite.png"
                      alt="Kooulu Logo"
                      width="1920"
                      height="575"
                    />
                  </a>
                </h3>
                <p style={{ fontSize: "16px", fontWeight: 600 }}>
                  KOOULU community of Tutors, Partners and centers provide
                  programs to nurture your child's curiosity and abilities so
                  they can be successful adults.
                </p>
                <div className="footer-social-desktop">
                  <h3 style={{ letterSpacing: "3px" }} className="text-white text-uppercase">
                    <b>Connect With Us</b>
                  </h3>
                  <div className="footer-icons-desktop">
                    <a href="https://www.facebook.com/kooulu" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                      <FiFacebook />
                    </a>
                    <a href="https://linkedin.com/company/kooulu" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                      <FiLinkedin />
                    </a>
                    <a href="https://bsky.app/profile/kooulu.bsky.social" target="_blank" rel="noopener noreferrer" aria-label="Bluesky">
                      <FaBluesky />
                    </a>
                  </div>
                </div>
                <p className="mobiledisplay" style={{ marginTop: "1.5rem", fontSize: "12px" }}>
                  © 2025. Kooulu All Rights Reserved.
                </p>
              </div>

              {/* Column 2: Menu */}
              <div className="col-lg-2 col-md-2 mb-4 mb-md-0" style={{ fontSize: "12px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1rem", letterSpacing: "3px", marginBottom: "20px" }} className="text-white text-uppercase">
                  <b>Menu</b>
                </h3>
                <ul className="list-unstyled mb-0">
                  {[
                    { label: "About Us",   path: "/aboutus" },
                    { label: "Contact Us", path: "/contactus" },
                    { label: "Activities", path: "/activities" },
                    { label: "Tutoring",   path: "/tutors/all" },
                    { label: "Centers",    path: "/childcare-facility-listing" },
                    { label: "Blogs",      path: "/blogs" },
                  ].map(({ label, path }) => (
                    <li key={label}>
                      <a href={path} className="text-white" onClick={goTo(path)}>{label}</a>
                    </li>
                  ))}
                </ul>
                <br />
                <p>
                  <a href="/terms-and-conditions" className="text-white" onClick={goTo("/terms-and-conditions")}>
                    <b>Terms & Conditions</b>
                  </a>
                </p>
              </div>

              {/* Column 3: Activities */}
              <div className="col-lg-2 col-md-2 mb-4 mb-md-0" style={{ fontSize: "12px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1rem", letterSpacing: "3px", marginBottom: "20px" }} className="text-white text-uppercase">
                  <b>Activities</b>
                </h3>
                <ul className="list-unstyled mb-0">
                  {COL3.map((cat) => (
                    <li key={cat}>
                      <a href={catLink(cat)} className="text-white" onClick={goTo(catLink(cat))}>{cat}</a>
                    </li>
                  ))}
                </ul>
                <br />
                <p>
                  <a href="/privacy-policy" className="text-white" onClick={goTo("/privacy-policy")}>
                    <b>Privacy Policies</b>
                  </a>
                </p>
              </div>

              {/* Column 4: More Activities */}
              <div className="col-lg-2 col-md-2 mb-4 mb-md-0" style={{ fontSize: "12px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1rem", letterSpacing: "3px", marginBottom: "20px" }} className="text-white text-uppercase">
                  <b>Activities</b>
                </h3>
                <ul className="list-unstyled mb-0">
                  {COL4.map((cat) => (
                    <li key={cat}>
                      <a href={catLink(cat)} className="text-white" onClick={goTo(catLink(cat))}>{cat}</a>
                    </li>
                  ))}
                </ul>
                <br />
                <p>
                  <a href="/faq" className="text-white" onClick={goTo("/faq")}>
                    <b>FAQ</b>
                  </a>
                </p>
              </div>

              {/* Column 5: More */}
              <div className="col-lg-3 col-md-2 mb-4 mb-md-0" style={{ fontSize: "12px", textAlign: "center" }}>
                <h3 style={{ fontSize: "1rem", letterSpacing: "3px", marginBottom: "20px" }} className="text-white text-uppercase">
                  <b>More</b>
                </h3>
                <ul className="list-unstyled mb-0">
                  <li>
                    <a href={catLink("Language / Culture")} className="text-white" onClick={goTo(catLink("Language / Culture"))}>
                      Language / Culture
                    </a>
                  </li>
                  <li>
                    <a href={catLink("Others")} className="text-white" onClick={goTo(catLink("Others"))}>
                      Others
                    </a>
                  </li>
                  <li>
                    <a href="/login-options" className="text-white" onClick={goTo("/login-options")}>
                      Partner Login / Registration
                    </a>
                  </li>
                  <li>
                    <a href="/parentlogin" className="text-white" onClick={goTo("/parentlogin")}>
                      Parent Login / Registration
                    </a>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        <br />
      </footer>

      {/* Mobile footer */}
      <footer className="text-white footerbg-mobile mobile-only mobile-footer-ui">
        <div className="container p-3">
          <div className="footer-section text-center">
            <a href="/" className="navbar-brand weblogo" onClick={goTo("/")}>
              <img
                src="/assets/images/logowhite.png"
                alt="Kooulu Logo"
                className="footer-logo-mobile"
                width="1920"
                height="575"
              />
            </a>
            <p className="footer-desc">
              KOOULU community of Tutors, Partners and centers provide programs
              to nurture your child's curiosity and abilities so they can be
              successful adults.
            </p>
          </div>

          <div className="footer-divider"></div>

          <div className="footer-menu">
            <div className="footer-menu-grid">
              <a href="/" className="text-white" onClick={goTo("/")}>Home</a>
              <a href="/aboutus" className="text-white" onClick={goTo("/aboutus")}>About Us</a>
              <a href="/tutors/all" className="text-white" onClick={goTo("/tutors/all")}>Tutoring</a>
              <a href="/activities" className="text-white" onClick={goTo("/activities")}>Activities</a>
              <a href="/contactus" className="text-white" onClick={goTo("/contactus")}>Contact Us</a>
              <a href="/childcare-facility-listing" className="text-white" onClick={goTo("/childcare-facility-listing")}>Centers</a>
            </div>
            <div className="footer-menu-col">
              <a href="/blogs" className="text-white" onClick={goTo("/blogs")}>Blogs</a>
              <a href="/login-options" className="text-white" onClick={goTo("/login-options")}>Partner Login / Registration</a>
              <a href="/parentlogin" className="text-white" onClick={goTo("/parentlogin")}>Parent Login / Registration</a>
            </div>
          </div>

          <div className="footer-divider"></div>

          <div className="footer-social text-center">
            <h3 className="text-white">Connect With Us</h3>
            <br />
            <div className="footer-icons">
              <a href="https://www.facebook.com/kooulu" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FiFacebook />
              </a>
              <a href="https://linkedin.com/company/kooulu" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FiLinkedin />
              </a>
              <a href="https://bsky.app/profile/kooulu.bsky.social" target="_blank" rel="noopener noreferrer" aria-label="Bluesky">
                <FaBluesky />
              </a>
            </div>
          </div>
          <br />
          <p className="footer-copy">© 2025. Kooulu All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
